"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectGameVars = selectGameVars;
exports.selectGameId = selectGameId;
exports.selectGameVarsState = selectGameVarsState;
exports.selectActiveStageName = selectActiveStageName;
exports.selectCurrentTimer = selectCurrentTimer;
exports.selectCurrentSlideNum = selectCurrentSlideNum;
exports.selectActiveStage = selectActiveStage;
exports.selectParentGameId = selectParentGameId;
exports.selectReportingConsoleId = selectReportingConsoleId;
exports.selectGameMapList = selectGameMapList;

var _constants = require("../constants");

function selectModule(state) {
  return state[_constants.GAME_VARS_MODULE_NAME];
}

function selectGameVarsState(state) {
  return selectModule(state).gameVars;
}

function selectGameVars(state) {
  return selectGameVarsState(state).data;
}

function selectActiveStage(state) {
  return selectGameVarsState(state).stage;
}

function selectCurrentTimer(state) {
  return selectGameVarsState(state).timer;
}

function selectCurrentSlideNum(state) {
  return selectGameVarsState(state).slideNum;
}

function selectActiveStageName(state) {
  return selectGameVarsState(state).stageName;
}

function selectReportingConsoleId(state) {
  return selectGameVarsState(state).reportingConsoleId;
}

function selectGameId(state) {
  return selectGameVarsState(state).gameId;
}

function selectParentGameId(state) {
  return selectGameVarsState(state).parentGameId;
}

function selectGameMapList(state) {
  return selectGameVarsState(state).mapList;
}